import type {MetaType} from "~/types/Meta";

export const fetchData = async <T>(url: string, options: any = {}) => {
    const config = useRuntimeConfig()

    try {
        const { data, error } = await useFetch<{
            success: boolean
            data?: T
            meta?: MetaType
            message?: string
            errors?: any[]
        }>(url, {
            baseURL: config.public.baseURL,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            ...options,
            onResponse({ response }) {
                const serverTime = response.headers.get('x-server-time')
                if (serverTime) {
                    const globalStore = useGlobalStore()
                    globalStore.setServerTime(serverTime)
                }
            },
        })

        if (error.value) {
            throw error.value
        }

        if (data.value?.success === false) {
            throw createError({
                message: data.value?.message || "Неизвестная ошибка",
                statusCode: 400,
                data: data.value?.errors || null
            })
        }

        return {
            data: data.value?.data,
            meta: data.value?.meta,
        }
    } catch (error: any) {
        if (error.statusCode === 401) {
            /*const userStore = useUserStore()
            authStore.logout()*/
            //navigateTo({name: 'auth'})
        }

        if (error.statusCode === 404 && (options.method || options.method === 'GET')) {
            navigateTo('/not-found')
        }

        throw error
    }
}